import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
import { cardType } from './interfaces/Enums';
import { cardOrientation } from './interfaces/Enums';
import { validatePackage } from '@progress/kendo-licensing';
import { packageMetadata } from '../package-metadata';
export var Card = function Card(props) {
  var _a;

  validatePackage(packageMetadata);
  return React.createElement("div", {
    dir: props.dir,
    style: props.style,
    className: classNames('k-card', props.className, (_a = {}, _a["k-state-" + props.type] = props.type !== cardType.DEFAULT, _a), props.orientation !== cardOrientation.HORIZONTAL ? 'k-card-vertical' : 'k-card-horizontal')
  }, props.children);
};
Card.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['default', 'primary', 'info', 'success', 'warning', 'error']),
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};
Card.defaultProps = {
  type: cardType.DEFAULT,
  orientation: cardOrientation.VERTICAL,
  dir: 'ltr'
};